module.exports = __webpack_public_path__ + "img/no_image.ae6dd4fa.jpg";